const itemsPerPage = 48;

export const mapForYouProductsAndFilters = (products) => {
  const categoryTags = ["bc-filter-Bags","bc-filter-Accessories","bc-filter-Watches","bc-filter-Jewelry","bc-filter-Apparel","bc-filter-Shoes"];
  const forYouProducts = [];
  const forYouFilters = {
    designers: [],
    categories: [],
    color: [],
    condition: [],
  };
  products.forEach((product) => {
    if (!forYouFilters.designers.includes(product.vendor)) {
      forYouFilters.designers.push(product.vendor);
    }
    let color = null;
    let condition = null;
    let category = null;
    product.tags.find((tag) => {
      if (categoryTags.includes(tag)) {
        if (!forYouFilters.categories.includes(tag.replace('bc-filter-', ''))) {
          forYouFilters.categories.push(tag.replace('bc-filter-', ''));
        }
        category = tag.replace('bc-filter-', '');
        return true;
      } else {
        return false;
      }
    })
    product.metafields.forEach((metafield) => {
      if (metafield.key === "exterior_color") {
        color = metafield.value;
        if (!forYouFilters.color.includes(metafield.value) && metafield.value !== '-') {
          forYouFilters.color.push(metafield.value);
        }
      }

      if (metafield.key === "condition") {
        condition = metafield.value;
        if (!forYouFilters.condition.includes(metafield.value)) {
          forYouFilters.condition.push(metafield.value);
        }
      }
    })
    forYouProducts.push({
      ...product,
      forYouFilters: {
        color: color,
        designers: product.vendor,
        condition: condition,
        categories: category
      }
    })
  })

  forYouFilters.color = forYouFilters.color.filter(color => color !== '-');

  return {forYouProducts, forYouFilters}
}

export const filterForYouProducts = (products, appliedFilters) => {
  let isAnyFilterApplied = false;
  Object.keys(appliedFilters).map((filterName) => {
    if (appliedFilters[filterName].length > 0) {
      isAnyFilterApplied = true;
    }
  })

  if (isAnyFilterApplied) {
    return products.filter((product) => {
      let matchedFilterNumber = 0;
      let appliedFilterNumber = 0;
      Object.keys(appliedFilters).map((filterName) => {
        const filter = appliedFilters[filterName];
        if (filter.length > 0) {
          appliedFilterNumber += 1;
          if (filter.includes(product.forYouFilters[filterName])) {
            matchedFilterNumber += 1;
          }
        }
      })
      return matchedFilterNumber === appliedFilterNumber ;
    })
  } else {
    return products
  }
}

export const showOnlyAvailableFilters = (allProducts, filteredProducts, appliedFilters, allFilters) => {
  const updateForYouFilters = {
    designers: new Set(),
    categories: new Set(),
    color: new Set(),
    condition: new Set(),
  };

  let numberOfFiltersApplied = 0;
  let appliedFilterNames = [];

  // Step 1: Identify which filters are currently applied
  for (const filterName in appliedFilters) {
    if (appliedFilters[filterName].length > 0) {
      numberOfFiltersApplied += 1;
      appliedFilterNames.push(filterName);
    }
  }

  // Case 1: No Filters Applied → Show All Available Options
  if (numberOfFiltersApplied === 0) {
    return {
      designers: allFilters.designers,
      categories: allFilters.categories,
      color: allFilters.color,
      condition: allFilters.condition,
    };
  }

  // Case 2: One Filter Applied → Show Full Options for that Filter, Limit Others
  if (numberOfFiltersApplied === 1) {
    const appliedFilter = appliedFilterNames[0];

    // 1️⃣ Keep all options for the selected filter
    updateForYouFilters[appliedFilter] = new Set(allFilters[appliedFilter]);

    // 2️⃣ Limit other filters to options from matching products
    filteredProducts.forEach((product) => {
      for (const filterName in updateForYouFilters) {
        if (filterName !== appliedFilter && product.forYouFilters[filterName]) {
          updateForYouFilters[filterName].add(product.forYouFilters[filterName]);
        }
      }
    });

    return {
      designers: Array.from(updateForYouFilters.designers),
      categories: Array.from(updateForYouFilters.categories),
      color: Array.from(updateForYouFilters.color),
      condition: Array.from(updateForYouFilters.condition),
    };
  }

  // Case 3: Two Filters Applied → Advanced Matching Logic
  if (numberOfFiltersApplied === 2) {
    const [filterA, filterB] = appliedFilterNames;

    // 1️⃣ Get all products that match **at least one of the applied filters**
    const matchingProductsA = allProducts.filter(product =>
      appliedFilters[filterA].includes(product.forYouFilters[filterA])
    );
    const matchingProductsB = allProducts.filter(product =>
      appliedFilters[filterB].includes(product.forYouFilters[filterB])
    );

    // 2️⃣ Designer & Color: Show all options available for **either filter**
    matchingProductsA.forEach(product => {
      updateForYouFilters.designers.add(product.forYouFilters.designers);
      updateForYouFilters.color.add(product.forYouFilters.color);
    });
    matchingProductsB.forEach(product => {
      updateForYouFilters.designers.add(product.forYouFilters.designers);
      updateForYouFilters.color.add(product.forYouFilters.color);
    });

    // 3️⃣ Category & Condition: Show only options that match **both filters**
    filteredProducts.forEach(product => {
      updateForYouFilters.categories.add(product.forYouFilters.categories);
      updateForYouFilters.condition.add(product.forYouFilters.condition);
    });

    return {
      designers: Array.from(updateForYouFilters.designers),
      categories: Array.from(updateForYouFilters.categories),
      color: Array.from(updateForYouFilters.color),
      condition: Array.from(updateForYouFilters.condition),
    };
  }

  // Case 4: More than Two Filters Applied → Limit All Filters to the Filtered Products
  filteredProducts.forEach((product) => {
    for (const filterName in updateForYouFilters) {
      if (product.forYouFilters[filterName]) {
        updateForYouFilters[filterName].add(product.forYouFilters[filterName]);
      }
    }
  });

  return {
    designers: Array.from(updateForYouFilters.designers),
    categories: Array.from(updateForYouFilters.categories),
    color: Array.from(updateForYouFilters.color),
    condition: Array.from(updateForYouFilters.condition),
  };
};


export const changePageForYou = (queryName, queryValue) => {
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url.search);
  if (params.has(queryName)) {
    params.set(queryName, queryValue);
  } else {
    params.append(queryName, queryValue);
  }
  url.search = params.toString();
  window.history.pushState({}, '', url.toString());
}

export const paginateForYouProducts = (products, currentPage) => {
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
  // If the total number of products is less than itemsPerPage, return all products
    if (products.length <= itemsPerPage) {
      return products;
    }

    if (startIndex >= products.length) {
      return [];
    }

    return products.slice(startIndex, endIndex);
}